import { render, staticRenderFns } from "./p33.vue?vue&type=template&id=19163cec&scoped=true&"
import script from "./p33.vue?vue&type=script&lang=js&"
export * from "./p33.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19163cec",
  null
  
)

export default component.exports